import React, { memo } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';

export default memo(({ width = '150px', height = '150px', src }) => {
    return <Player autoplay loop src={src} style={{ height, width }}></Player>;
});
